import { render } from "./AcitivityPageList.vue?vue&type=template&id=6f71e2aa&ts=true"
import script from "./AcitivityPageList.vue?vue&type=script&lang=ts"
export * from "./AcitivityPageList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__